export const environment = {
  production: false,
  requireAuthGlobal: true,
};
